export default "__VITE_ASSET__B56K0tOP__"